// =============================================================================
// SIREPPAR - Límites de longitud compartidos por la UI
// =============================================================================
// Acá viven los topes que el backend valida y que la UI tiene que respetar. Están
// en un archivo propio porque el mismo número lo necesitan pantallas que no se
// importan entre sí, y repetirlo garantizaba que se fueran separando.
//
// Cada constante ESPEJA una validación del backend. Si se toca una, hay que tocar
// la otra: el `maxLength` del campo sólo evita el viaje que termina en 400.
// =============================================================================

/**
 * Motivo de revisión de un documento, en cualquiera de sus dos dimensiones
 * (admisibilidad y análisis).
 *
 * Es el texto que después se le transcribe al partido en la observación, así que
 * tiene que dar para detallar qué está mal en una carta orgánica o en un acta.
 *
 * Espeja MAX_OBSERVACION_DOC de controllers/documentoController.ts.
 */
export const MAX_MOTIVO_DOCUMENTO = 200000;

// =============================================================================
// Topes de VISTA — cuánto se muestra antes de "Leer más"
// =============================================================================
// No son validaciones: el texto completo ya está en el cliente. Sólo deciden
// cuánto se pinta de entrada, para que un motivo de doscientas mil letras no
// empuje el resto de la pantalla fuera de la vista.

/** Observación / intimación del expediente (pestaña Comunicaciones). */
export const PREVIEW_OBSERVACION = 2000;

/** Motivo de un archivo, en el detalle del documento. */
export const PREVIEW_MOTIVO_DOCUMENTO = 500;

/**
 * Motivo de un archivo cuando viaja en una línea de resumen (el subtítulo de una
 * fila plegada, o el renglón del tablero de secciones). Ahí no hay lugar para un
 * "Leer más" — la fila entera ya es un botón que despliega el detalle, y el
 * motivo completo aparece ahí.
 */
export const RESUMEN_MOTIVO_LINEA = 160;
